<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex offset-xl-4 xl4 offset-lg-4 lg4 offset-md-4 md3 xs12>
        <v-card>
          <v-card-title primary-title>Urkunde herunterladen</v-card-title>
          <v-card-text>
            Der Download der Urkunde startet automatisch. Sollte dies nicht der Fall sein verhindert dein Browser eventuell das Öffnen von Popus. <br>
            <br>
            <v-alert v-if="showWarning === true" type="warning">Der Download ist erst nach Abschluss der Veranstaltung möglich.</v-alert>
            <v-btn v-if="showWarning === false" @click="downloadCertificate()">Urkunde herunterladen</v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

  import axios from "axios";

  export default {
    computed: {
      uuid() {
        return this.$route.params.uuid
      }
    },
    methods: {
      downloadCertificate() {
        axios.get('/public/certificate/' + this.$route.params.uuid, { responseType: 'blob'}).then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' })
          window.open(window.URL.createObjectURL(blob))
        }).catch(() => {
          this.showWarning = true
        })
      }
    },
    data: function () {
      return {
        showWarning: false
     }
    },
    created () {
      this.downloadCertificate()
    }
  }
</script>
